import { GridColDef } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import { TextSpan } from '../../Atoms/Text';
import { Icon } from '../../Atoms/Icon';
import { FileUploadResponse } from '../../../store/Link';
import { BasicDataGrid } from '../../Compounds/Table/BasicDataGrid';

export interface ErrorDisplay {
  rpmAccountId: number;
  id: string;
  error: string;
}

export interface UploadSummaryParams {
  uploadResponse: FileUploadResponse;
}

export const UploadSummary = ({ uploadResponse }: UploadSummaryParams) => {
  const [errors, setErrors] = useState<ErrorDisplay[]>([]);

  useEffect(() => {
    if (uploadResponse.errors.length) {
      const err: ErrorDisplay[] = uploadResponse.errors.map((e) => ({
        rpmAccountId: e.link.rpmAccountId,
        id: e.link.id ?? '',
        error: e.error
      }));
      setErrors(err);
    }
  }, [uploadResponse]);

  const successCols: GridColDef[] = [
    { headerName: 'RPM Account', field: 'rpmAccountId', width: 250 },
    { headerName: 'Status', field: 'status', width: 250 },
    { headerName: 'ID', field: 'id', flex: 1 }
  ];

  const failureCols: GridColDef[] = [
    { headerName: 'RPM Account', field: 'rpmAccountId', width: 250 },
    { headerName: 'ID', field: 'id', flex: 1 },
    { headerName: 'Message', field: 'error', flex: 1 }
  ];

  return (
    <>
      <div data-testid="upload-summary-container">
        <TextSpan
          size="sm14"
          dataTestId="upload-response-message">
          {uploadResponse.message}
        </TextSpan>
        {!!uploadResponse?.success.length && (
          <>
            <TextSpan className="flex items-center py-3">
              <Icon
                type="circlemark"
                className="p-3"
              />
              {uploadResponse?.success.length} links fixed
            </TextSpan>
            <BasicDataGrid
              rows={uploadResponse?.success || []}
              columns={successCols}
            />
          </>
        )}
        {!!errors.length && (
          <>
            <TextSpan className="flex items-center py-3">
              <Icon
                type="alert"
                className="p-3"
              />
              {errors.length} failed
            </TextSpan>
            <BasicDataGrid
              rows={errors}
              columns={failureCols}
            />
          </>
        )}
      </div>
    </>
  );
};
